<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">
            {{ $route.meta.title }}
          </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="savePartner()"
              class="min-button"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="customer.url_picture"
                          v-bind:style="{
                            backgroundImage: 'url(' + customer.url_picture + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12"
              v-if="partnerType === 'travel_agency'"
            >
              <div class="card ">
                <h2 class="subtitle">Credit</h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-2 col-md-12 col-sm-3 col-12 switch-md mb-2"
                  >
                    <base-switch
                      onText="Yes"
                      offText="No"
                      class="sw-md"
                      v-model="customer.credit.status"
                      tabindex="20"
                      @input="changeStatusCredit"
                    ></base-switch>
                  </div>

                  <div
                    class="col-xl-12 col-lg-5 col-md-6 col-sm-4 col-12"
                    v-if="customer.credit.status"
                  >
                    <BaseNumberInput
                      v-model.number="$v.customer.credit.limit.$model"
                      label="Credit limit"
                      placeholder="Credit limit"
                      id="limit_credit"
                      name="limit_credit"
                      maxlength="6"
                      tabindex="21"
                      format="capitalize"
                      class="input-append with-prepend"
                      markrequired
                      :error="
                        $v.customer.credit.limit.$error
                          ? `Enter a limit credit`
                          : ''
                      "
                    >
                      <template slot="prepend">{{
                        customer.currency.symbol
                      }}</template>
                      <template slot="append">{{
                        customer.currency.code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                  <div
                    class="col-xl-12 col-lg-5 col-md-6 col-sm-4 col-12"
                    v-if="customer.credit.status"
                  >
                    <BaseNumberInput
                      v-model.number="customer.credit.available"
                      label="Available Credit"
                      placeholder="Available Credit"
                      id="available_credit"
                      name="available_credit"
                      readonly
                      maxlength="45"
                      tabindex="22"
                      class="input-append with-prepend"
                      disabled
                    >
                      <template slot="prepend">{{
                        customer.currency.symbol
                      }}</template>
                      <template slot="append">{{
                        customer.currency.code
                      }}</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card ">
                <h2 class="subtitle">Notes</h2>
                <div class="row">
                  <div class="col-12">
                    <div class="mb-4 ">
                      <el-input
                        v-model="$v.customer.notes.$model"
                        placeholder="Special Requirements"
                        id="customer_notes"
                        name="customer_notes"
                        tabindex="23"
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            type="primary"
          >
            <tab-pane
              class="tabs-home-content"
              id="Overview"
              title="Overview"
              ref="Overview"
            >
              <div class="card">
                <h2 class="subtitle">
                  Partner Type
                </h2>

                <div
                  class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                >
                  <b-form-radio-group
                    id="btn-radios-1"
                    v-model="partnerType"
                    :options="typeOptions"
                    name="radios-btn-default"
                    buttons
                    value-field="value"
                    text-field="label"
                    button-variant="group-neutral"
                    tabindex="1"
                    @change="selectPartnerType"
                    class="buttons-type mb-3"
                  ></b-form-radio-group>
                </div>

                <div class="d-xl-none d-lg-none d-md-none d-sm-none d-block">
                  <WSelect
                    id="typeCustomer"
                    name="typeCustomer"
                    placeholder="Type"
                    v-model="partnerType"
                    label="Type Partner"
                  >
                    <el-option
                      v-for="option in typeOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">
                  Business Details
                </h2>

                <div class="row mt-2" v-if="partnerType === 'travel_agency'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.company_name.$model"
                          label="Agency Name"
                          placeholder="Agency Name"
                          id="bussiness_name"
                          name="bussiness_name"
                          tabindex="1"
                          maxlength="45"
                          @input="changeCompanyName"
                          markrequired
                          :error="
                            !$v.customer.company_name.minLength ||
                            $v.customer.company_name.$error
                              ? `Enter from ${$v.customer.company_name.$params.minLength.min} to ${$v.customer.company_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.legal_name.$model"
                          label="Legal Name"
                          placeholder="Legal Name"
                          id="bussiness_Legalname"
                          name="bussiness_Legalname"
                          tabindex="2"
                          maxlength="45"
                          :error="
                            !$v.customer.legal_name.minLength ||
                            $v.customer.legal_name.$error
                              ? `Enter from ${$v.customer.legal_name.$params.minLength.min} to ${$v.customer.legal_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.iata_code.$model"
                          label="IATA Code"
                          placeholder="IATA Code"
                          id="bussiness_iata_code"
                          name="bussiness_iata_code"
                          tabindex="2"
                          maxlength="45"
                          :error="
                            $v.customer.iata_code.$error
                              ? `Enter from ${$v.customer.iata_code.$params.minLength.min} to ${$v.customer.iata_code.$params.maxLength.max} characters`
                              : ''
                          "
                        />
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.vat_number.$model"
                          label="VAT Number"
                          placeholder="VAT Number"
                          id="bussiness_VatNumber"
                          name="bussiness_VatNumber"
                          tabindex="2"
                          maxlength="45"
                          @input="changeVATNumber"
                          :error="
                            $v.customer.vat_number.$error
                              ? `Enter from ${$v.customer.vat_number.$params.minLength.min} to ${$v.customer.vat_number.$params.maxLength.max} characters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label class="title-label"
                          >Managed Account
                          <el-popover
                            placement="top"
                            trigger="hover"
                            width="300"
                            class="curp"
                          >
                            <span>
                              Activate this option if the account is
                              administered and/or managed by a Travel Agency
                            </span>
                            <div class="badge badge-primary" slot="reference">
                              ?
                            </div>
                          </el-popover></label
                        >
                        <base-switch
                          v-model="customer.managed_account"
                          class="sw-md mt-2 ml-3"
                        ></base-switch>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2" v-if="partnerType === 'travel_access'">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <WSelect
                          v-bind:class="{
                            'invalid-feedback': $v.customer.association.$error
                          }"
                          v-model="$v.customer.association.$model"
                          label="Partner agency"
                          placeholder="Select an Agency Name"
                          id="agency_name"
                          name="agency_name"
                          tabindex="3"
                          remote
                          filterable
                          reserve-keyword
                          clearable
                          markrequired
                          :error="
                            $v.customer.association.$error
                              ? `Select an Agency`
                              : ''
                          "
                          @change="selectAgency"
                        >
                          <el-option
                            v-for="(agency, index) in agencies"
                            :value="agency._id"
                            :label="agency.company_name"
                            :key="index"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card  ">
                <h2 class="subtitle">Main Contact</h2>
                <div class="row">
                  <div class="col-xl-12 mt-2">
                    <div class="row">
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.first_name.$model"
                          label="First Name"
                          placeholder="First Name"
                          id="first_name"
                          name="first_name"
                          maxlength="45"
                          tabindex="1"
                          format="capitalize"
                          markrequired
                          :error="
                            !$v.customer.first_name.minLength ||
                            $v.customer.first_name.$error
                              ? `Enter from ${$v.customer.first_name.$params.minLength.min} to ${$v.customer.first_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model.trim="$v.customer.last_name.$model"
                          label="Last Name"
                          placeholder="Last Name"
                          id="last_name"
                          name="last_name"
                          maxlength="45"
                          tabindex="2"
                          format="capitalize"
                          markrequired
                          :error="
                            !$v.customer.last_name.minLength ||
                            $v.customer.last_name.$error
                              ? `Enter from ${$v.customer.last_name.$params.minLength.min} to ${$v.customer.last_name.$params.maxLength.max} letters`
                              : ''
                          "
                        />
                      </div>
                      <div
                        class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 form-group"
                        v-bind:class="{
                          'is-invalid': $v.customer.gender.$error
                        }"
                      >
                        <label for="title" class="title-label">Gender</label>
                        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                          <b-form-radio-group
                            v-model="$v.customer.gender.$model"
                            :aria-describedby="ariaDescribedby"
                            id="radio-gender"
                            name="radio-gender"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                            tabindex="3"
                          >
                            <b-form-radio value="male" class="pc-4" tabindex="3"
                              >Mr.</b-form-radio
                            >
                            <b-form-radio value="female" class="pc-4"
                              >Mrs.</b-form-radio
                            >
                            <b-form-radio value="other" class="pc-4"
                              >Mx.</b-form-radio
                            >
                          </b-form-radio-group>
                        </b-form-group>

                        <small
                          class="invalid-feedback mt-1"
                          v-if="$v.customer.gender.$error"
                          >Select</small
                        >
                      </div>

                      <div
                        class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
                      >
                        <label
                          class="title-label"
                          v-bind:class="{
                            'is-invalid': $v.customer.phone.$error
                          }"
                          ><span class="markrequired">*</span>Contact
                          Number</label
                        >
                        <vue-tel-input
                          v-model="phoneFormat"
                          key="NumberPhoneCustomer"
                          inputId="NumberPhoneCustomer"
                          name="NumberPhoneCustomer"
                          required
                          mode="international"
                          inputClasses="input no-label no-err"
                          :dynamicPlaceholder="true"
                          :disabledFetchingCountry="true"
                          :validCharactersOnly="true"
                          :wrapperClasses="[
                            $v.customer.phone.$error ? 'is-invalid' : '',
                            'mb-0'
                          ]"
                          @validate="phoneInput"
                          tabindex="6"
                        ></vue-tel-input>
                        <small
                          class="invalid-feedback mt-1"
                          v-if="$v.customer.phone.$error"
                          >Enter a valid Phone Number</small
                        >
                      </div>

                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                        <label class="title-label">Other Contact Info</label>
                        <div class="d-flex">
                          <b-form-group
                            v-slot="{ ariaDescribedby2 }"
                            class="d-inline-flex"
                          >
                            <b-form-radio-group
                              v-model="customer.other_contact_platform"
                              :aria-describedby="ariaDescribedby2"
                              id="radio-contact"
                              name="radio-contact"
                              tabindex="7"
                              buttons
                              button-variant="outline-neutral"
                              size="md"
                            >
                              <b-form-radio
                                value="Whatsapp"
                                class="pc-2"
                                title="Whatsapp"
                                tabindex="7"
                                ><i class="flaticon-bold-whatsapp f16"></i
                              ></b-form-radio>
                              <b-form-radio
                                value="Skype"
                                class="pc-2"
                                title="Skype"
                                ><i
                                  class="flaticon-bold-logotipo-de-skype f16"
                                ></i
                              ></b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>

                          <base-input
                            v-model.trim="customer.contact_info"
                            placeholder="Other Contact Info"
                            id="passengers_phone_optional"
                            name="passengers_phone_optional"
                            tabindex="8"
                            class="d-inline-flex"
                          >
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card  ">
                <h2 class="subtitle">Account Info</h2>

                <div class="row mt-2">
                  <div class="col-xl-12">
                    <div class="row">
                      <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <base-input
                          label="Email Address"
                          placeholder="Email Address"
                          id="customer_email"
                          name="customer_email"
                          maxlength="100"
                          tabindex="14"
                          format="lowercase"
                          autocomplete="off"
                          markrequired
                          v-model="$v.customer.email.$model"
                          @input="changeCompanyEmail"
                          :error="getEmailValidationMessage($v.customer.email)"
                        />
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"
                      ></div>

                      <div
                        class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12"
                      ></div>

                      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                        <base-input
                          v-model="$v.customer.password.$model"
                          label="Password"
                          placeholder="Password"
                          name="password"
                          id="password"
                          :type="typePassword"
                          autocomplete="new-password"
                          maxlength="20"
                          tabindex="15"
                          class="input-append mb-0"
                          markrequired
                          :tooltip="true"
                          titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                          contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                          v-bind:class="{
                            'is-invalid': $v.customer.password.$error
                          }"
                          ><template slot="append">
                            <span @click="seePassword()" class="icon-button"
                              ><i
                                v-bind:class="{
                                  'flaticon-view-1': typePassword == 'password',
                                  'flaticon-hidden': typePassword == 'text'
                                }"
                              ></i
                            ></span>
                          </template>
                        </base-input>
                        <small
                          class="invalid-feedback mt--1 mb-3"
                          v-if="$v.customer.password.$error"
                          >{{ validatePassword($v.customer.password) }}</small
                        >

                        <small
                          class="valid-feedback mt-0 mb-3"
                          v-if="$v.customer.password.strongPassword"
                          >Strong Password</small
                        >
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
                      >
                        <base-input
                          v-model.trim="$v.repeatPassword.$model"
                          label="Confirm Password"
                          placeholder="Confirm Password "
                          type="password"
                          id="confirm_password"
                          name="confirm_password"
                          maxlength="20"
                          tabindex="16"
                          :error="
                            !$v.repeatPassword.sameAsPassword ||
                            $v.repeatPassword.$error
                              ? `Passwords must be identical`
                              : ''
                          "
                        />
                      </div>

                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
                      >
                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          @click="autogeneratePass()"
                        >
                          <i class="flaticon-bold-lock"></i>Generate Password
                        </base-button>

                        <base-button
                          type="outline-secondary"
                          class="min-button"
                          v-clipboard:copy="customer.password"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onErrorCopy"
                          v-if="customer.password"
                        >
                          <i class="flaticon-copy"></i>Copy Password
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card ">
                <h2 class="subtitle">Address</h2>

                <div class="row mt-2">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.customer.street.$model"
                      label="Street address, apartment, suite, etc."
                      placeholder="Street address, apartment, suite, etc"
                      id="customer_street"
                      name="customer_street"
                      maxlength="200"
                      tabindex="9"
                      format="capitalize"
                      :error="
                        !$v.customer.street.minLength ||
                        $v.customer.street.$error
                          ? `Enter from ${$v.customer.street.$params.minLength.min} to ${$v.customer.street.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.customer.city.$model"
                      label="City"
                      placeholder="City"
                      id="customer_city"
                      name="customer_city"
                      maxlength="45"
                      tabindex="10"
                      format="capitalize"
                      :error="
                        !$v.customer.city.minLength || $v.customer.city.$error
                          ? `Enter from ${$v.customer.city.$params.minLength.min} to ${$v.customer.city.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.customer.state.$model"
                      label="State/Province/Region"
                      placeholder="State/Province/Region"
                      id="customer_state"
                      name="customer_state"
                      maxlength="45"
                      tabindex="11"
                      format="capitalize"
                      :error="
                        !$v.customer.state.minLength || $v.customer.state.$error
                          ? `Enter from ${$v.customer.state.$params.minLength.min} to ${$v.customer.state.$params.maxLength.max} letters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model.trim="$v.customer.zip_code.$model"
                      label="Zip/Postal Code"
                      placeholder="Zip/Postal Code"
                      id="customer_zipcode"
                      name="customer_zipcode"
                      maxlength="45"
                      tabindex="12"
                      :error="
                        !$v.customer.zip_code.minLength ||
                        $v.customer.zip_code.$error
                          ? `Enter from ${$v.customer.zip_code.$params.minLength.min} to ${$v.customer.zip_code.$params.maxLength.max} characters`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <WSelect
                      v-bind:class="{
                        'invalid-feedback': $v.customer.country.$error
                      }"
                      v-model="$v.customer.country.$model"
                      label="Country"
                      placeholder="Enter a Country"
                      id="customer_country"
                      name="customer_country"
                      tabindex="13"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="searchCountry"
                      :loading="loading"
                      clearable
                    >
                      <el-option
                        v-for="country in countriesOptions"
                        :value="country.name"
                        :label="country.name"
                        :key="country.name"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="paymentInfo"
              title="Payment Info"
              ref="paymentInfo"
            >
              <div class="card">
                <div class="row mt-2 align-items-center">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <BaseNumberInput
                      v-model.number="$v.customer.mark_up.$model"
                      label="Markup"
                      placeholder="Markup"
                      id="customer_markup"
                      name="customer_markup"
                      maxlength="3"
                      tabindex="17"
                      class="input-append"
                      markrequired
                      @input="validateMarkup"
                      :error="
                        !$v.customer.mark_up.between
                          ? `Must be between ${$v.customer.mark_up.$params.between.min} to ${$v.customer.mark_up.$params.between.max}`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 switch-x-l form-group"
                  >
                    <label class="title-label">Commercial Terms</label>

                    <b-form-group v-slot="ariaDescribedby3" class="mb-2">
                      <b-form-radio-group
                        v-model="customer.type_charge"
                        :aria-describedby="ariaDescribedby3"
                        @change="changeCommercialTerms"
                        id="radio-commercial"
                        name="radio-comercial"
                        buttons
                        button-variant="outline-neutral"
                        size="md"
                      >
                        <b-form-radio
                          value="commission"
                          tabindex="18"
                          class="pc-0"
                          >Commission</b-form-radio
                        >
                        <b-form-radio value="net_price" class="pc-1"
                          >Net Price</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12"
                    v-if="customer.type_charge === 'commission'"
                  >
                    <BaseNumberInput
                      v-model.number="$v.customer.commission.$model"
                      @input="changeCommision"
                      label="Commision"
                      placeholder="Commision"
                      id="commission"
                      name="commission"
                      maxlength="3"
                      class="input-append"
                      tabindex="19"
                      markrequired
                      :error="
                        $v.customer.commission.$error
                          ? `Must be between ${$v.customer.commission.$params.between.min}% to ${$v.customer.commission.$params.between.max}%`
                          : ''
                      "
                    >
                      <template slot="append">%</template>
                    </BaseNumberInput>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                    <WSelect
                      :disabled="hasCredit"
                      v-model="currencyCode"
                      label="Currency"
                      placeholder="Currency"
                      id="customer_currency"
                      name="customer_currency"
                      tabindex="20"
                    >
                      <el-option
                        v-for="(coin, index) in coins"
                        :value="coin.code"
                        :label="coin.label"
                        :key="index"
                      >
                        <span class="coin-left">{{ coin.label }}</span>
                        <span class="coin-right">{{ coin.symbol }}</span>
                      </el-option>
                    </WSelect>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  numeric,
  minValue,
  requiredIf,
  decimal,
  between,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { PartnersAPI, AuthAPI } from "../../../core/api";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import lodash from "lodash";
import generator from "generate-password";
import Swal from "sweetalert2";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import { FileService } from "../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewPartners",
  data() {
    return {
      customer: {
        type: "travel_agency",
        first_name: "",
        last_name: "",
        full_name: "",
        email: "",
        password: "",
        phone: "",
        contact_info: "",
        gender: "other",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        notes: "",
        company_name: "",
        type_markup: "markup",
        type_charge: "net_price",
        vat_number: "",
        mark_up: 32,
        session: true,
        status: true,
        relationship: {
          owner: "",
          type: "admin"
        },
        other_contact_platform: "",
        currency: {
          code: "USD",
          symbol: "$",
          label: "US Dollar"
        },
        credit: {
          status: false,
          limit: 0,
          available: 0
        },
        source: "rhomtrip",
        url_picture: "",
        iata_code: "",
        legal_name: "",
        payment_methods: [],
        association: null,
        approve: true,
        managed_account: true,
        commission: 10,
        settings: {
          brand: {
            logos: {
              default: "",
              favicon: ""
            },
            colors: {
              primary: "#4b56a6",
              buttonText: "#FFFFFF",
              inTheme: false
            },
            theme: {
              color: "#4b56a6",
              buttonText: "#FFFFFF"
            }
          },
          socialmedia: {
            facebook: "",
            twitter: "",
            instagram: "",
            linkedin: ""
          },
          permissions: {
            brand: false,
            notifications: false
          },
          entityDetails: {
            company: {
              relationship: true,
              name: "",
              email: "",
              vatnumber: ""
            },
            contact: {
              phoneNumber: "",
              email: ""
            },
            pages: {
              web: "",
              contact: "",
              faq: "",
              termsConditions: ""
            },
            importantNote: ""
          }
        }
      },
      loading: false,
      countriesOptions: [],
      type: "travel_agency",
      typeOptions: this.$route.query.association
        ? [{ value: "travel_access", label: "Travel Agent" }]
        : [
            { value: "travel_agency", label: "Travel Agency" },
            { value: "travel_access", label: "Travel Agent" }
          ],
      saved: false,
      contact_platform: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Skype", label: "Skype" }
      ],
      coins: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      currencyCode: "USD",
      customerCopy: {},
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      tabActive: "",
      phoneFormat: "",
      repeatPassword: "",
      typePassword: "password",
      partnerType: "travel_agency",
      agencies: [],
      lastCommission: 10,
      hasCredit: false
    };
  },
  async created() {
    this.agencies = await this.getPartnersOptions();
    this.partnerType = this.$route.query.partnerType
      ? this.$route.query.partnerType
      : "travel_agency";

    this.customer.type = this.partnerType;
    this.customer.association = this.$route.query.association
      ? this.$route.query.association
      : null;
    if (this.customer.association) {
      this.selectAgency(this.customer.association);
    }
    this.customerCopy = lodash.cloneDeep(this.customer);
    this.countriesOptions = this.countries;
  },
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Partners",
        to: "/partners"
      },
      {
        text: "New Partner",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  watch: {
    currencyCode: {
      handler: function(current, old) {
        let currency = this.coins.find(element => element.code === current);
        this.customer.currency = {
          code: currency ? currency.code : "",
          symbol: currency ? currency.symbol : "",
          label: currency ? currency.label : ""
        };
      },
      deep: true
    },
    "customer.credit.limit": {
      handler: function(current, old) {
        this.customer.credit.available = current;
      },
      deep: true
    }
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/users/avatars",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.customer.url_picture = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.customer.url_picture = "";
      this.picture = "";
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    phoneInput(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      } else {
        this.customer.phone = "";
      }
    },
    validatePassword(password) {
      if (password.$error) {
        if (!password.minLength) {
          return `Password must have at least ${password.$params.minLength.min} letters`;
        } else if (password.required && password.$model.length < 1) {
          return `Password is required`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    validateMarkup(value) {
      if (parseFloat(value) < 0) {
        this.customer.mark_up = 0;
      }
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.customer.password = password;
      this.repeatPassword = password;
    },
    async createPartner(partner, router) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.createPartners(
          partner,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Partner has been Saved",
            icon: "flaticon-check-3"
          });
          let newPartner = data.data.partner;
          if (router) {
            this.$router.push(router);
          } else {
            this.$router.push(
              newPartner ? `/partners/${newPartner._id}` : "partners"
            );
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the Partner, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.saved = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Partner, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async savePartner(router = null) {
      if (!this.$v.customer.$invalid) {
        let customer = lodash.cloneDeep(this.customer);
        customer.full_name = `${customer.first_name} ${customer.last_name}`;
        customer.email = customer.email.toLowerCase();
        await this.createPartner(customer, router);
      } else {
        this.$v.customer.$touch();
        this.$v.repeatPassword.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Email is required";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await AuthAPI.checkUniqueEmail(email.toLowerCase());
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    async getPartnersOptions() {
      try {
        let { data } = await PartnersAPI.getPartnersOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectPartnerType(value) {
      this.customer.type = value;
    },
    isInPartnerModule(modules = []) {
      if (!(modules.indexOf("partners") > -1)) {
        this.setPartnerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(from, to, next) {
      let isEqual = lodash.isEqual(this.customer, this.customerCopy);
      if (!isEqual && !this.saved && this.canUserCreate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The Partner has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.savePartner(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    selectAgency(agencyId) {
      let agency = this.agencies.find(agency => agency._id === agencyId);
      if (agency) {
        this.customer.commission = agency.commission;
        this.lastCommission = agency.commission;
        this.customer.mark_up = agency.mark_up;
        this.customer.type_charge = agency.type_charge;
        this.customer.type_markup = agency.type_markup;
        this.currencyCode = agency.currency.code;
        this.hasCredit = agency.credit.status;
        //Settings
        this.customer.settings.brand = agency.settings.brand;
        this.customer.settings.permissions.brand =
          agency.settings.permissions.brand;
        this.customer.settings.entityDetails.company.name =
          agency.settings.entityDetails.company.name;
        this.customer.settings.entityDetails.company.vatnumber =
          agency.settings.entityDetails.company.vatnumber;
      }
    },
    changeCommercialTerms(value) {
      if (value === "net_price") {
        this.customer.commission = 0;
      } else {
        this.customer.commission =
          this.lastCommission === 0 ? 10 : this.lastCommission;
      }
    },
    changeCommision(value) {
      this.lastCommission = parseInt(value);
    },
    changeStatusCredit(value) {
      this.hasCredit = value;
    },
    changeCompanyName(value) {
      this.customer.settings.entityDetails.company.name = value;
    },
    changeVATNumber(value) {
      this.customer.settings.entityDetails.company.vatnumber = value;
    },
    changeCompanyEmail(value) {
      this.customer.settings.entityDetails.company.email = value;
    },
    ...mapMutations(["setLoad", "setItemsBread", "setPartnerSearchCriteria"]),
    ...mapActions(["getAgents", "getLimit"])
  },
  computed: {
    ...mapGetters([
      "countries",
      "sesion",
      "userRole",
      "load",
      "agents",
      "paginationLimit"
    ]),
    canUserCreate() {
      return isUserAuthorized("PARTNERS", this.userRole, "CREATE");
    }
  },
  validations: {
    customer: {
      first_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      company_name: {
        required: requiredIf(function(value) {
          return "travel_agency" === this.partnerType;
        }),
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      legal_name: {
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      iata_code: {
        minLength: minLength(5),
        maxLength: maxLength(25)
      },
      vat_number: {
        minLength: minLength(5),
        maxLength: maxLength(25)
      },
      mark_up: {
        numeric,
        decimal,
        between: between(0, 100),
        minLength: minLength(1),
        maxLength: maxLength(2)
      },
      email: {
        required,
        email,
        customValidator: async function(value) {
          if (this.validateEmail(value)) {
            return await this.verifyEmailCustomer(value);
          } else {
            return false;
          }
        }
      },
      gender: {
        required: true
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      },
      country: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      city: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      state: {
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      zip_code: {
        minLength: minLength(4),
        maxLength: maxLength(10)
      },
      street: {
        minLength: minLength(5),
        maxLength: maxLength(100)
      },
      type: {
        required
      },
      notes: {
        maxLength: maxLength(200)
      },
      password: {
        required,
        minLength: minLength(8),
        strongPassword(password) {
          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          );
        }
      },
      credit: {
        status: {
          required: requiredIf(function(value) {
            return (
              this.customer.type === "travel_agency" &&
              this.customer.credit.status
            );
          })
        },
        limit: {
          required: requiredIf(function(value) {
            return (
              this.customer.type === "travel_agency" &&
              this.customer.credit.status
            );
          }),
          minValue: 0
        },
        available: {
          required: requiredIf(function(value) {
            return (
              this.customer.type === "travel_agency" &&
              this.customer.credit.status
            );
          })
        }
      },
      currency: {
        required: requiredIf(function(value) {
          return this.customer.type === "travel_agency";
        })
      },
      association: {
        required: requiredIf(function(value) {
          return this.customer.type !== "travel_agency";
        })
      },
      commission: {
        numeric,
        decimal,
        between: between(0, 100)
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.customer.password;
      })
    }
  },
  components: {
    flatPicker,
    VueTelInput,
    WSelect
  },
  filters: {
    typeUser: function(type) {
      if (type === "travel_agency") {
        return "Travel Agency";
      } else {
        return "Agent";
      }
    },
    commercialTerms: function(type) {
      if (type === "commission") {
        return "Commission";
      } else {
        return "Net Price";
      }
    },
    gender: function(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Mx.";
      }
    },
    typeOperator: function(type) {
      if (type === "travel_access") {
        return "Manager Access";
      } else {
        return "Manager Access";
      }
    },
    statusOperator: function(status) {
      if (status) {
        return "Active";
      } else {
        return "Inactive";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInPartnerModule(to.meta.modules);
    this.detectChanges(from, to, next);
  }
};
</script>
